module.exports = __webpack_public_path__ + "pc/img/body_basic-5.29a4e5b8.png";